import { render, staticRenderFns } from "./TypePathologyForm.vue?vue&type=template&id=5a05132f&"
import script from "./TypePathologyForm.vue?vue&type=script&lang=js&"
export * from "./TypePathologyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports